const shopFixOnly = ['S312', 'S084']

export default { shopFixOnly }
